import styled from 'styled-components';

import {formGrid} from '../../Pages/CreateProjectGRA/StyledStep';

export default styled.div`
	${formGrid}
`;
